enum WorkspaceProjectFundingMilestoneBatchStatus {
  'Waiting for funding' = 'Waiting for funding',
  'To do' = 'To do',
  'In progress' = 'In progress',
  'Released' = 'Released',
}

export default WorkspaceProjectFundingMilestoneBatchStatus
